import { IsArray, IsBoolean, IsNotEmpty, IsOptional, IsString, IsUUID } from 'class-validator';

export class GetLeaderboardDto {
	@IsString()
	@IsNotEmpty()
	eventId: string;

	@IsString()
	@IsNotEmpty()
	lobbyId: string;

	@IsOptional()
	@IsArray()
	@IsUUID('4', { each: true })
	matchIds: string[];

	@IsOptional()
	@IsBoolean()
	isOverall: boolean;
}
